import { render, staticRenderFns } from "./ProductComparativeCard.vue?vue&type=template&id=cf51e1c0&scoped=true"
import script from "./ProductComparativeCard.vue?vue&type=script&lang=js"
export * from "./ProductComparativeCard.vue?vue&type=script&lang=js"
import style0 from "./ProductComparativeCard.vue?vue&type=style&index=0&id=cf51e1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf51e1c0",
  null
  
)

export default component.exports